import React from 'react';
import { AlertCircle, WifiOff, ServerCrash, RefreshCw } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  const { t } = useLanguage();
  
  const getErrorIcon = () => {
    if (message.includes('internet') || message.includes('bağlantı') || message.includes('connection')) {
      return <WifiOff className="w-8 h-8 text-red-600" />;
    } else if (message.includes('sunucu') || message.includes('server')) {
      return <ServerCrash className="w-8 h-8 text-red-600" />;
    } else {
      return <AlertCircle className="w-8 h-8 text-red-600" />;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="p-6 bg-white rounded-lg shadow-md max-w-md w-full">
        <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full bg-red-100">
          {getErrorIcon()}
        </div>
        <h2 className="mb-4 text-xl font-semibold text-center text-gray-900">{t('error.title')}</h2>
        <p className="mb-5 text-center text-gray-600">{message}</p>
        <div className="bg-gray-50 p-4 rounded-md mb-5">
          <p className="text-sm text-gray-700">
            <strong>{t('error.solutions')}</strong>
          </p>
          <ul className="list-disc pl-5 mt-1 text-sm text-gray-600 space-y-1">
            <li>{t('error.checkInternet')}</li>
            <li>{t('error.refreshPage')}</li>
            <li>{t('error.tryAgainLater')}</li>
            <li>{t('error.tryDifferentBrowser')}</li>
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={() => window.location.reload()}
            className="py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-md transition duration-150 ease-in-out flex-1 flex items-center justify-center"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            {t('error.refresh')}
          </button>
          <button
            onClick={onRetry || (() => window.location.reload())}
            className="py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition duration-150 ease-in-out flex-1 flex items-center justify-center"
          >
            {t('error.retry')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;